import { setTag } from '@sentry/react';
import { isEmptyString, oz } from '@vy/utils';
import { jwtDecode } from 'jwt-decode';
import { clarity } from 'react-microsoft-clarity';
import { isProduction } from '../utils/env-indicator';
import { initHotjar } from '../utils/hotjar-config';
import { getLocalStorageString } from '../utils/local-storage';

export function useIntegrations() {
  const token = getLocalStorageString('token');

  if (isEmptyString(token)) {
    return;
  }

  const DecodedJwtSchema = oz.custom<{
    email: string;
    ['custom:accountId']: string;
    ['auth_time']: number;
  }>();

  const decoded = jwtDecode(token);
  const parsedDecodedJwt = DecodedJwtSchema.safeParse(decoded);

  if (!parsedDecodedJwt.success) {
    return;
  }

  const { email, ['custom:accountId']: accountId, ['auth_time']: authTime } = parsedDecodedJwt.data;

  setTag('user.email', email);
  setTag('user.accountId', accountId);
  setTag('user.authTime', authTime * 1000);

  initClarity(email, accountId);
  initTracking(email);
}

function initTracking(email: string) {
  if (isProduction() && !isVayuUser(email)) {
    initHotjar();
  }
}

function initClarity(email: string, accountId: string) {
  const clarityId = 'lxhxzzd6a3';

  if (isProduction() && !isVayuUser(email)) {
    clarity.init(clarityId);
    clarity.setTag('email', email);
    clarity.setTag('accountId', accountId);
    clarity.setTag('developer', 'true');
  }
}
function isVayuUser(email: string) {
  return email.endsWith('@withvayu.com') || email.endsWith('@goweft.com');
}
